import {AbstractAPIPlatformProvider} from './abstract';
import {Role as RoleModel} from '../model';
import {PROVIDER} from '../../../resources/bcmApi';

export class Role extends AbstractAPIPlatformProvider {
  name = PROVIDER.ROLES;
  model = new RoleModel();
}
